/* RESPONSIBLE TEAM: team-inbox-experience */
export enum InboxCategory {
  Shared = 'shared',
  Admin = 'admin',
  Team = 'team',
  View = 'view',
  Dashboard = 'dashboard',
}
